// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.my-profile .scrollable-div[data-v-007b4ef8] {\n    height: 465px;\n    overflow-y: auto;\n}\n.v-application .primary--text[data-v-007b4ef8] {\n    color: white !important;\n}\n.input-label[data-v-007b4ef8] {\n    font-weight: bold;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
